/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */

import { LogLevel } from '@azure/msal-browser';

const api = {
  clientId: import.meta.env.VITE_MSAL_API_CLIENT_ID,
  tenantId: import.meta.env.VITE_MSAL_TENANT_ID,
};

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: import.meta.env.VITE_MSAL_AUTHORITY,
    redirectUri: import.meta.env.VITE_API_URL,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: false,
    popupRedirectResolver: (url) =>
      url.includes("login.microsoftonline.com"),
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;

        // switch (level) {
        //   case LogLevel.Error:
        //     console.log(message);
        //     break;
        //   case LogLevel.Info:
        //     console.info(message);
        //      break;
        //   case LogLevel.Verbose:
        //     console.debug(message);
        //      break;
        //   case LogLevel.Warning:
        //     console.warn(message);
        // }
      },
    },
  },
};

export const loginRequest = {
  scopes: [`api://${api.clientId}/Api.ReadWrite`],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
